// Module
var code = "<react-component name=\"WorkoutMembersList\"></react-component>\n";
// Exports
module.exports = code;